import { type PropsWithChildren, createContext, useContext, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { UrlShortenerStore } from 'pages/settings/pages/urlShortener/store/UrlShortenerStore'

const UrlShortenerContext = createContext<UrlShortenerStore | null>(null)

export const useUrlShortenerContext = () => {
  const context = useContext(UrlShortenerContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with UrlShortenerProvider')

  return context
}

export const UrlShortenerProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new UrlShortenerStore(entities))

  return <UrlShortenerContext.Provider value={store}>{children}</UrlShortenerContext.Provider>
}
